import React, { useState } from "react";
import useApiService from "../../../services/useApiService";
import { getCurrentLanguage } from "../../../helpers/local_storage";

export default function TranslatableCellFormatter(props) {
  const {
    cell,
    row,
    rowIndex,
    column,
    getRowTranslation,
    rowTranslationStatuses,
    onTranslationRequested,
    onTranslationSuccess,
    onTranslationFailed,
  } = props;
  const [_, translate] = useApiService({ url: "/translations/translate_details", method: "post", onSuccess, onError });
  const [isShowTranslation, setIsShowTranslation] = useState(true);

  const isCellEmpty = cell && cell.trim();
  const { row: sourceDetails, translation } = getRowTranslation(row.id) || {};

  const translationStatus = rowTranslationStatuses.find((item) => item.rowId === row.id);
  const isTranslating = translationStatus && translationStatus.status == "loading";
  const isTranslationFailed = translationStatus && translationStatus.status == "failed";

  const translationSourceText = sourceDetails && sourceDetails[column.dataField];
  const cellTranslation = translation && translation[column.dataField];
  const isTranslationShown = !isTranslating && isShowTranslation && cellTranslation && cellTranslation.text;

  function onSuccess(data) {
    onTranslationSuccess(row, data.translation);
  }

  function onError() {
    onTranslationFailed(row.id);
  }

  function onTranslateClick(event) {
    event.stopPropagation();
    setIsShowTranslation(true);

    // prevent re-translation if the cell has not changed.
    if (translationSourceText === cell) {
      return;
    }

    const currentLanguage = getCurrentLanguage();
    const language = currentLanguage === "portuguese"? "brazilian portuguese": currentLanguage
  
    onTranslationRequested(row.id);
    translate({
      source_details: {
        consequences_description: row.consequences_description,
        actions: row.actions,
        effectiveness: row.effectiveness,
        effectiveness2: row.effectiveness2,
      },
      target_language: language,
      translation_engine: "openai",
    });
  }

  function onShowOriginalClick(event) {
    event.stopPropagation();
    setIsShowTranslation(false);
  }

  function onCellClick(event) {
    if (isTranslating || isTranslationShown) {
      // prevent editing while cell translation is on going and showing translation.
      event.stopPropagation();
    }
  }

  const translationValue = isTranslationShown && cellTranslation && cellTranslation.text;
  const showTranslateButton = !!isCellEmpty && !isTranslationShown && !isTranslating;
  const showOriginalButton = isTranslationShown && !isTranslating;

  return (
    <div className="translatable-cell-renderer" onClick={onCellClick}>
      <div className="cell-style" cell={cell} row={rowIndex}>
        {isTranslationShown && isCellEmpty && cellTranslation && (
          <div>
            <b>{cellTranslation.label}:</b>
          </div>
        )}
        {translationValue || cell}
      </div>
      <div className="translation-indicators">
        {isTranslating && (
          <div className="pending-translation">
            Translating <div className="ui active inline loader"></div>
          </div>
        )}
        {isTranslationFailed && <div className="failed-translation">Translation failed.</div>}
      </div>
      <div className="translation-actions">
        {showOriginalButton && (
          <span className="link text-light-blue" onClick={onShowOriginalClick}>
            Show Original
          </span>
        )}
        {showTranslateButton && (
          <span className="link text-light-blue" onClick={onTranslateClick}>
            Translate
          </span>
        )}
      </div>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/views/plan_tables/formatters/translatable_cell_formatter.js